function initDealerMap() {
    if (window.jQuery) {
        (function ($, maps) {
            $(function () {
                $('.dealers-widget').each(function () {
                    var $widget = $(this);

                    var bounds = new maps.LatLngBounds();

                    var $map = $widget.find('.dealer-map');
                    var map = new maps.Map($map[0], {
                        
                        // musste raus: mapTypeId: "OSM",
                        mapTypeControl: false,
                        streetViewControl: false,
                        
                        /* neu => */ //center: {lat: 51.2418916, lng: 7.1637667},
                        zoom: 15
                    });

                    function getScaledSize() {
                        var height = Math.min($map.height(), 700);
                        var scale = height / 700;
                        return new maps.Size(110 * 0.5 * scale, 150 * 0.5 * scale);
                    }
                    
                    var lastInfoWindow = null;
                    function openDealerInfo(dealer) {
                        lastInfoWindow && lastInfoWindow.close();
                        lastInfoWindow = dealer.info;
                        dealer.info.open(map, dealer.marker);
                    }

                    var btnText = $map.data('route-btn-text');

                    var $dealers = $widget.find('.dealer');
                    var dealers = $dealers.map(function (i) {
                        var $dealer = $(this);

                        var latitude = $dealer.data('latitude');
                        var longitude = $dealer.data('longitude');
                        var latLng = new maps.LatLng(latitude, longitude);

                        var company = $dealer.find('.company').html();
                        var street = $dealer.find('.street').html();
                        var zipcodeCity = $dealer.find('.zipcode-city').html();
                        var routeUrl = 'https://www.google.com/maps/search/?api=1&query=' + street + '+' + zipcodeCity + '+' + company;

                        var contentString =
                            '<div class="content">' +
                                '<h4>' + company + '</h4 >' +
                                '<div class="address">' +
                                    '<p>' + street + '</p>' +
                                    '<p>' + zipcodeCity + '</p>' +
                                '</div>' +
                                '<a target="_blank" class="btn btn-primary btn-arrow" href="' + routeUrl + '">' + btnText + '</a>' +
                            '</div>';

                        var dealer = {
                            marker: new maps.Marker({
                                position: latLng,
                                icon: {
                                    url: '/Features/Indeca/Salesman/SalesmanModule/pointer-0' + (i + 1) + '.svg',
                                    scaledSize: getScaledSize()
                                },
                                map: map
                            }),
                            info: new maps.InfoWindow({
                                content: contentString
                            })
                        };

                        dealer.marker.addListener('click', function () {
                            openDealerInfo(dealer);
                        });

                        bounds.extend(dealer.marker.position);

                        return dealer;
                    });

                    map.fitBounds(bounds);

                    $dealers.on('click', function() {
                        var index = $(this).data('index');
                        var dealer = dealers[index];
                        openDealerInfo(dealer);
                        $('html, body').animate({
                            scrollTop: $map.offset().top - $('.bes-page-header').height()
                        });
                    });

                    $(window).on('resize', function() {
                        map.fitBounds(bounds);

                        dealers.each(function() {
                            var icon = this.marker.getIcon();
                            icon.scaledSize = getScaledSize();
                            this.marker.setIcon(icon);
                        });
                    });
                });
            });
        })(window.jQuery, window.google.maps);
    } else {
        setTimeout(initDealerMap, 100);
    }
}
function ensureGoogleApi($) {
        if (typeof google === "undefined" || typeof google.maps === "undefined") {
            if (!document.mapsPromise) {
                if (document.googleApiKey) {
                    document.mapsPromise =
                        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + document.googleApiKey + '&callback=Function.prototype');
                } else {
                    console.error('Required Google API key is missing');
                }
            }
            return document.mapsPromise;
        }
        return new $.Deferred().resolve(google.maps);
}

function initDealersSearchMap() {
    if (typeof google !== "undefined" && typeof google.maps !== "undefined") {
        initDealerMap();
    } else {
        setTimeout(initDealersSearchMap, 100);
    }
}
function initDealers() {
    if (window.jQuery) {
        var widget = window.jQuery('.dealers-widget');
        if (widget && widget.length > 0) {
            var apiPromise = ensureGoogleApi(window.jQuery);
            if (apiPromise) {
                apiPromise.then(initDealersSearchMap());
            }
        }
    } else {
        setTimeout(initDealers, 100);
    }
}

document.addEventListener("DOMContentLoaded",
    function () {
            initDealers();
    });